<template>
    <div>*-*</div>
</template>

<script>
export default {
    name: 'mped-home-view',
};
</script>

<style scoped>

</style>
